export enum EMoments {
	MATIN = "MATIN",
	APRES_MIDI = "APRES-MIDI",
	SOIR = "SOIR",
	NUIT = "NUIT",
}
